import { render, staticRenderFns } from "./botMigration.vue?vue&type=template&id=e5fe0992&scoped=true"
import script from "./botMigration.vue?vue&type=script&lang=js"
export * from "./botMigration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fe0992",
  null
  
)

export default component.exports